/**
 * Hook for managing ethnic backgrounds selection
 */

import { useQuery } from "@tanstack/react-query"
import { getEthnicBackgrounds } from "../services/user.service"

export function useEthnicBackgrounds() {
  const {
    data: backgrounds = [],
    isLoading,
    error,
    refetch,
  } = useQuery({
    queryKey: ["ethnic-backgrounds"],
    queryFn: getEthnicBackgrounds,
    staleTime: 5 * 60 * 1000, // 5 minutes
  })

  return {
    backgrounds,
    isLoading,
    error,
    refetch,
  }
}
